<div class="mobile-overlay" [ngClass]="{ 'active' : mobileDropdownLinksOpen || mobileDropdownLanguagesOpen }"></div>
<header>

  <nav class="navbar fixed-top navbar-expand-lg navbar-dark background-dark general-dark2-bg d-flex">
    <div class="logo-box">
      <div class="logo-wrapper">
        <a class="navbar-brand" href="#" routerLink="/">
          <!--<img class="img-fluid logo logo-icon" style="margin-top: -5px;" src="/assets/images/pl-header-icon.svg" alt="FMLA Home">-->
          <!--<img class="img-fluid logo logo-icon" style="margin-top: -5px; max-height: 50px;" src="/assets/images/header-logo.svg" alt="FMLA Home">-->
          <img class="img-fluid logo logo-icon desktop" style="margin-top: -5px; max-height: 50px;" src="/assets/images/header-logo.svg" alt="FMLA Home" aria-label="FMLA Home">
          <img class="img-fluid logo logo-icon mobile" style="margin-top: -5px; max-height: 50px;" src="/assets/images/header-logo-mobile.svg" alt="FMLA Home" aria-label="FMLA Home">
        </a>
      </div>
    </div>


    <div class="icons d-flex d-xl-none position-relative">
      <span class="language-icon d-block d-lg-none" (click)="toggleDropdownLanguages()"><i class="fas fa-globe-americas"></i></span>
      <div class="ml-auto mobile-cart d-block d-lg-none">
        <div *ngIf="itemsInCartCount > 0" class="nav-item cursor-pointer" data-toggle="modal" data-target="#shoppingCartModal">
          <span class="nav-link cart" href="#"><i class="fa fa-shopping-cart"></i> <span class="badge badge-danger">{{itemsInCartCount}}</span></span>
        </div>
      </div>
      <button class="navbar-toggler" (click)="toggleDropdownLinks()">
        <span class="navbar-toggler-icon position-relative" style="line-height: 25px;"></span>
      </button>
    </div>

    <div class="toolbar text-white description d-none d-xl-flex">
      <div class="logo-box-spacer"></div>
      <div class="spacer nobr dropdown dropdown-toggle cursor-pointer" data-toggle="dropdown">
        <i class="fas fa-globe-americas"></i>
          <span class="ml-1" *ngIf="!['/spanish', '/german', '/french', '/japanese', '/chinese', '/korean'].includes(page)">English</span>
          <span class="ml-1" *ngIf="page === '/spanish'">Español</span>
          <span class="ml-1" *ngIf="page === '/german'">Deutsche</span>
          <span class="ml-1" *ngIf="page === '/french'">Français</span>
          <span class="ml-1" *ngIf="page === '/japanese'">日本語</span>
          <span class="ml-1" *ngIf="page === '/chinese'">中文</span>
          <span class="ml-1" *ngIf="page === '/korean'">한국어</span>
        <div class="dropdown-menu header-menu-language">
          <a class="dropdown-item" routerLink="/home">English</a>
          <a class="dropdown-item" [ngClass]="{'active': page === '/spanish'}" routerLink="/spanish">Español</a>
          <a class="dropdown-item" [ngClass]="{'active': page === '/german'}" routerLink="/german">Deutsche</a>
          <a class="dropdown-item" [ngClass]="{'active': page === '/french'}" routerLink="/french">Français</a>
          <a class="dropdown-item" [ngClass]="{'active': page === '/japanese'}" routerLink="/japanese">日本語</a>
          <a class="dropdown-item" [ngClass]="{'active': page === '/chinese'}" routerLink="/chinese">中文</a>
          <a class="dropdown-item" [ngClass]="{'active': page === '/korean'}" routerLink="/korean">한국어</a>
        </div>
      </div>
      <div class="spacer nobr" *ngIf="!!currentWeather">
        <!--<i class="fas fa-cloud"></i>-->
        <i class="wi {{ getIcon() }}"></i> {{ getTemp() }}°
      </div>
      <div class="spacer nobr open-daily">
        <i class="fas fa-clock"></i> Open Daily
      </div>
      <div class="spacer nobr">
        <i class="fas fa-map-marker-alt mr-1"></i> <span class="cursor-pointer"
          (click)="goto('https://www.google.com/maps/place/The+Original+Farmers+Market/@34.0720115,-118.3625639,17z/data=!3m1!4b1!4m5!3m4!1s0x80c2b930558eeb99:0x71a9177e9e240546!8m2!3d34.0720115!4d-118.3603699')">6333 W. 3rd St. Los Angeles</span>
      </div>
    </div>

    <div class="collapse navbar-collapse d-none d-lg-block">
      <ul class="navbar-nav ml-auto">
        <!-- <li class="nav-item" [ngClass]="{'active': page === '/visit'}">
          <a class="nav-link" href="#" routerLink="/visit">Visit</a>
        </li> -->
        <li class="nav-item cursor-pointer" [ngClass]="{'active': !!page && page.startsWith('/visit')}">
          <a class="nav-link dropdown dropdown-toggle" (mouseenter)="visitMenuEnter()" (mouseleave)="visitMenuOut()"
             routerLink="/visit" [ngClass]="{'hover': visitMenuHovered}">Visit

            <div class="dropdown-menu header-menu">
              <div class="spacer"></div>
              <a class="dropdown-item" (click)="visitMenuClicked($event)" routerLink="/visit">Map</a>
              <a class="dropdown-item" (click)="visitMenuClicked($event)" routerLink="/visit" fragment="market-map-header">Directory</a>
              <a class="dropdown-item" (click)="visitMenuClicked($event)" routerLink="/visit" fragment="parking">Parking</a>
              <a class="dropdown-item" (click)="visitMenuClicked($event)" routerLink="/visit" fragment="tours-attractions">Tours</a>
              <a class="dropdown-item" (click)="visitMenuClicked($event)" routerLink="/visit" fragment="hotels">Area Hotels</a>
              <a class="dropdown-item" (click)="visitMenuClicked($event)" routerLink="/visit" fragment="faq">FAQ</a>
            </div>
          </a>
        </li>
        <li class="nav-item" [ngClass]="{'active': !!page && page.startsWith('/merchants')}">
          <a class="nav-link" href="#" routerLink="/merchants">Merchants</a>
        </li>
        <li class="nav-item" [ngClass]="{'active': !!page && page.startsWith('/events')}">
          <a class="nav-link" href="#" routerLink="/events">Events</a>
        </li>
       <li class="nav-item" [ngClass]="{'active': !!page && page.startsWith('/delivery')}">
         <a class="nav-link" href="#" routerLink="/delivery">Delivery</a>
       </li>
        <li class="nav-item" [ngClass]="{'active': !!page && page.startsWith('/market-buzz')}">
          <a class="nav-link nobr" href="#" routerLink="/market-buzz">Market Buzz</a>
        </li>
        <li class="nav-item" [ngClass]="{'active': !!page && (page.startsWith('/store') || page.startsWith('/history') || page.startsWith('/lax') || page.startsWith('/market-office'))}">
          <a class="nav-link dropdown dropdown-toggle cursor-pointer" (mouseenter)="moreMenuEnter()" (mouseleave)="moreMenuOut()"
             [ngClass]="{'hover': moreMenuHovered}">More

          <div class="dropdown-menu header-menu">
            <div class="spacer"></div>
            <a class="dropdown-item" routerLink="/market-buzz/categories/99/Newsletter">Newsletter</a>
            <a class="dropdown-item" [ngClass]="{'active': !!page && page.startsWith('/store')}" routerLink="/store">Store</a>
            <a class="dropdown-item" [ngClass]="{'active': page === '/history'}" routerLink="/history">History</a>
            <!-- <a class="dropdown-item" [ngClass]="{'active': page === '/lax'}" routerLink="/lax">LAX</a> -->
            <a class="dropdown-item nobr" [ngClass]="{'active': page === '/market-office'}" routerLink="/market-office">Contact Us</a>
          </div>
        </a>
        </li>
        <!-- <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" data-flip="true" aria-haspopup="true" aria-expanded="false">
            More
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" href="#">Action</a>
            <a class="dropdown-item" href="#">Another action</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#">Something else here</a>
          </div>
        </li> -->
        <li class="nav-item" class="nav-item cursor-pointer" data-toggle="modal" data-target="#searchModal">
          <span class="nav-link search cursor-pointer" href="#"><i class="fa fa-search"></i></span>
        </li>

        <li *ngIf="itemsInCartCount > 0" class="nav-item cursor-pointer" data-toggle="modal"
          data-target="#shoppingCartModal">
          <span class="nav-link cart" href="#"><i class="fa fa-shopping-cart"></i> <span
              class="badge badge-danger">{{itemsInCartCount}}</span></span>
        </li>

      </ul>
    </div>

    <div class="d-block d-lg-none">
      <div class="responsive-dropdown mobile-nav" (dragstart)="scroll($event)" (drag)="scroll($event)">
        <app-mobile-nav-parts *ngIf="mobileDropdownLinksOpen" [includeLinks]="true"></app-mobile-nav-parts>
      </div>

      <div class="responsive-dropdown text-center" [ngClass]="{ 'disabled' : !mobileDropdownLanguagesOpen }">
        <h3 class="title language-title">Language</h3>
        <div class="language-buttons">
          <button class="btn btn-secondary1 language-button" href="#" routerLink="">English</button>
          <button class="btn btn-secondary1 language-button" href="#" routerLink="/spanish">Español</button>
          <button class="btn btn-secondary1 language-button" href="#" routerLink="/german">Deutsche</button>
          <button class="btn btn-secondary1 language-button" href="#" routerLink="/french">Français</button>
          <button class="btn btn-secondary1 language-button" href="#" routerLink="/japanese">日本語</button>
          <button class="btn btn-secondary1 language-button" href="#" routerLink="/chinese">中文</button>
          <button class="btn btn-secondary1 language-button" href="#" routerLink="/korean">한국어</button>
        </div>
      </div>
    </div>


  </nav>

  <!-- shopping cart slide-out -->
  <div class="modal fade" id="shoppingCartModal" tabindex="-1" role="dialog" aria-labelledby="shoppingCartModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-slideout modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title h6 neutral3" id="shoppingCartModalLabel">Cart</div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <div class="h6 brown3 cart-margin" aria-hidden="true">close x</div>
          </button>
        </div>
        <div class="modal-body cream1-bg p-0">
          <app-shopping-cart [hideHeader]="false"></app-shopping-cart>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary1" [class.enabled]="itemsInCartCount == 0"
            routerLink="/store/checkout" enabled>Checkout</button>
        </div>
      </div>
    </div>
  </div>

  <!-- search modal -->
  <div class="modal fade p-0 show" id="searchModal" tabindex="-1" role="dialog" aria-labelledby="searchModalLabel" aria-hidden="true" (focus)="searchOpened()" (blur)="searchClosed()">
    <div class="modal-dialog modal-dialog-centered modal-full" role="document">
      <div class="modal-content">
        <div class="logo-box">
          <div class="logo-wrapper">
            <a class="navbar-brand" href="#" routerLink="/">
              <!--<img class="img-fluid logo logo-icon" style="margin-top: -5px;" src="/assets/images/pl-header-icon.svg" alt="FMLA Home">-->
              <!--<img class="img-fluid logo logo-icon" style="margin-top: -5px; max-height: 50px;" src="/assets/images/header-logo.svg" alt="FMLA Home">-->
              <img class="img-fluid logo logo-icon desktop" style="margin-top: -5px; max-height: 50px;" src="/assets/images/header-logo.svg" alt="FMLA Home" aria-label="FMLA Home">
              <img class="img-fluid logo logo-icon mobile" style="margin-top: -5px; max-height: 50px;" src="/assets/images/header-logo-mobile.svg" alt="FMLA Home" aria-label="FMLA Home">
            </a>
          </div>
        </div>
        <div class="modal-header">

          <div class="d-flex w-100 h-100">

            <!--<a class="navbar-brand" href="#" routerLink="/">-->
              <!--<img class="img-fluid logo logo-icon" style="margin-top: -5px;" src="/assets/images/pl-header-icon.svg" alt="FMLA Home">-->
            <!--</a>-->
            <div class="logo-box-spacer"></div>

            <div class="search p-2">
              <i class="fa fa-search general-white"></i>
            </div>

            <div class="flex-fill">
              <input #searchInput type="text" class="form-control gray4" placeholder="Search"
                     (keyup)="keyUp($event)"
                     [(ngModel)]="searchText"
                     id="member-searchbar"
                     placeholder="Search Farmers Market..." autofocus autocomplete="off">
            </div>

            <div class="close-wrapper">
              <a class="close cursor-pointer" data-dismiss="modal" aria-label="cancel">
                <div class="h6 m-0 gray4 text-nowrap" aria-hidden="true">cancel x</div>
              </a>
            </div>
          </div>

        </div>
        <div class="modal-body super-dark-green-bg m-0 p-0 search-results">

          <app-search></app-search>

        </div>
      </div>
    </div>
  </div>
</header>
